<script>
  import { onMount } from "svelte";
  import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
  import backend from "../../../../../server";

  import Paginator from "./../../../../components/Pagination.svelte";
  import SearchSelect from "./SearchSelect.svelte";
  import { paramsGames } from "./stores.js";

  export let isSelectGames;
  export let configBonnus;
  export let onSave;

  let games = [];
  let messageGames = null;
  let isLoadingGames = false;
  let loading = false;
  let brands = [];
  let providers = [];
  let categorys = [];
  let selectedGames = configBonnus.games ?? [];

  const getProviders = async (prms) => {
    try {
      loading = true;
      let response = await backend.provider.lists(prms);
      let { data } = response;
      providers = data;
    } catch (e) {
    } finally {
      loading = false;
    }
  };
  const getBrands = async (prms) => {
    try {
      loading = true;
      let response = await backend.brands.listBrandsByProvider(prms);
      let { data } = response;
      brands = data;
    } catch (e) {
    } finally {
      loading = false;
    }
  };

  const getCategory = async (prms) => {
    try {
      loading = true;
      let response = await backend.games.listCategories(prms);
      let { data } = response;
      categorys = data;
    } catch (e) {
    } finally {
      loading = false;
    }
  };
  const fieldsToGames = ["searching", "brand", "provider", "category"];
  function clearField(field) {
    paramsGames.update((g) => {
      g[field] = "";
      g.page = 1;
      return g;
    });
    getGames();
  }

  async function getGames() {
    try {
      isLoadingGames = true;
      messageGames = null;
      const $g = $paramsGames;
      let response = await backend.games.list($g);
      let { data } = response;
      games = data.list || [];
      paramsGames.update((g) => ({
        ...g,
        total: Number(data.total),
        page: Number(data.page),
        xpage: Number(data.xpage),
        searching: g.search || g.searching,
        search: "",
      }));
      //selectedGamesIds = [];
    } catch (e) {
      messageGames = `Error al cargar games: ${e.message}. Por favor, intente de nuevo.`;
    } finally {
      isLoadingGames = false;
    }
  }
  onMount(() => {
    getProviders({});
    getCategory({});
    getBrands({});
  });
  const changePageGames = (newPage) => {
    paramsGames.update((g) => ({ ...g, page: newPage }));
    getGames();
  };

  const selectGameRow = (game) => {
    const exists = selectedGames.find((g) => g.gameid === game.gameid);
    if (exists) {
      // quitar si ya estaba
      selectedGames = selectedGames.filter((g) => g.gameid !== game.gameid);
    } else {
      // agregar objeto completo
      selectedGames = [...selectedGames, game];
    }
  };

  $: gamesFiltered = games.filter((game) =>
    (game.name || "").toLowerCase().includes($paramsGames.search.toLowerCase())
  );

  const closed = () => (isSelectGames = !isSelectGames);

  function gamesSave() {
    const updatedConfig = {
      ...configBonnus,
      games: selectedGames, // ahora son objetos completos
    };
    onSave && onSave(updatedConfig);
  }

  const searchGames = () => {
    getGames();
  };

  const onChangeBrands = (e) => {
    paramsGames.update((p) => ({ ...p, brand: e.detail }));
  };
  const onChangeCategory = (e) => {
    paramsGames.update((p) => ({ ...p, category: e.detail }));
  };
  const onChangeProvider = (e) => {
    paramsGames.update((p) => ({ ...p, provider: e.detail }));
  };
</script>

<Modal isOpen={isSelectGames} toggle={closed} size="xl">
  <ModalHeader toggle={closed}>Seleccionar juegos</ModalHeader>
  <ModalBody>
    <div class="row">
      <div class="col-md-4">
        <b>Marca</b>
        {#key $paramsGames.brand}
        <SearchSelect
          items={brands}
          placeholder="Búscar marca"
          on:change={onChangeBrands}
        />
        {/key}
      </div>

      <div class="col-md-4">
        <b>Provider</b>
        {#key $paramsGames.provider}
        <SearchSelect
          items={providers}
          placeholder="Búscar Provrdores"
          on:change={onChangeProvider}
        />
        {/key}
      </div>

      <div class="col-md-4">
        <b>Category</b>
        {#key $paramsGames.category}
          <SearchSelect
            items={categorys}
            placeholder="Búscar categorías"
            on:change={onChangeCategory}
          />
        {/key}
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="input-group" style=" gap: 8px; margin: 3px">
          <input
            type="search"
            placeholder="Ingrese nombre del juego"
            class="form-control"
            bind:value={$paramsGames.search}
            on:keydown={(e) => e.key === "Enter" && searchGames()}
          />
          {#if $paramsGames.search?.trim() !== "" || $paramsGames.brand?.trim() !== "" || $paramsGames.provider?.trim() !== "" || $paramsGames.category?.trim() !== "" || gamesFiltered.length === 0}
            <button
              type="button"
              class="btn btn btn-outline-secondary"
              on:click={searchGames}
            >
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          {/if}
        </div>
      </div>

      {#each fieldsToGames as field}
        {#if $paramsGames[field]?.trim() !== ""}
          <div
            class="d-inline-flex align-items-center bg-dark text-white rounded-pill gap-1 mt-2 px-2"
            style="max-width: max-content; white-space: nowrap; padding: 2px 8px; font-size: 0.75rem; line-height: 1; margin-left: 13px; "
          >
            <span
              >{field.charAt(0).toUpperCase() + field.slice(1)}: {$paramsGames[
                field
              ]}</span
            >
            <button
              type="button"
              class="btn-close btn-close-white btn-sm"
              aria-label="Cerrar"
              on:click={() => clearField(field)}
            ></button>
          </div>
        {/if}
      {/each}

      <div class="table-responsive">
        <table
          class="table table-striped table-hover table-bordered align-middle"
        >
          <thead>
            <tr>
              <th>N°</th>
              <th>Juego</th>
              <th>Marca</th>
              <th>Provrdor</th>
              <th>Categoria</th>
              <th style="text-align: center;">Selected</th>
            </tr>
          </thead>
          <tbody>
            {#if isLoadingGames}
              <tr
                ><td colspan="6" style="text-align: center;">Loading...</td></tr
              >
            {:else if messageGames}
              <tr
                ><td colspan="6" style="color: red; text-align: center;"
                  >{messageGames}</td
                ></tr
              >
            {:else if gamesFiltered.length === 0}
              <tr
                ><td colspan="6" style=" color: #888; text-align: center;"
                  >No hay juegos en esta página. Usa la búsqueda. 🔍</td
                ></tr
              >
            {:else}
              {#each gamesFiltered as game, index}
                <tr
                  on:click={() => selectGameRow(game)}
                  class:selected={selectedGames.some(
                    (g) => g.gameid === game.gameid
                  )}
                  style="cursor: pointer;"
                >
                  <td
                    >{($paramsGames.page - 1) * $paramsGames.xpage +
                      index +
                      1}</td
                  >
                  <td>{game.name} - {game.gameid}</td>
                  <td>{game.brand}</td>
                  <td>{game.provider}</td>
                  <td>{game.category}</td>
                  <td style="text-align: center;">
                    {#if selectedGames.some((g) => g.gameid === game.gameid)}✔️{/if}
                  </td>
                </tr>
              {/each}
            {/if}
          </tbody>
        </table>
      </div>
      <Paginator
        current={$paramsGames.page}
        total={$paramsGames.total}
        xpage={$paramsGames.xpage}
        onPageClick={changePageGames}
      />
    </div>
  </ModalBody>
  <ModalFooter>
    <button class="btn btn-primary" on:click={() => gamesSave()}>
      extraer
    </button>
  </ModalFooter>
</Modal>
